/* eslint-disable prettier/prettier */
import React from 'react';
import {
  Collapse,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

import { useLocation } from 'react-router-dom';
import { IMenuItemProps, IItemProps } from './types';
import useStyles from './style';

const Item = ({
  route,
  component,
  handleClick,
  children,
  endAdornment,
  isChildren,
}: IItemProps) => {
  const { pathname } = useLocation();
  const classes = useStyles({ isChildren });

  // TODO: mapear interface de props extras
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const extraProps = {} as any;

  if (!children) {
    extraProps.to = route.path;
    extraProps.component = component;
  }

  const isSelected = route.path === pathname;

  return (
    <>
      <ListItem
        className={classes.menuItem}
        selected={isSelected}
        onClick={handleClick}
        key={route.name}
        {...extraProps}
      >
        <ListItemText
          primary={(
            <Typography
              className={
                isChildren ? classes.itemTextChild : classes.itemTextParent
              }
            >
              {route.meta.title}
            </Typography>
          )}
        />
        {endAdornment}
      </ListItem>
      {children}
    </>
  );
};

const MenuItem = ({ route, component, toggleDrawer }: IMenuItemProps) => {
  const menuItemClasses = useStyles();
  const [open, setOpen] = React.useState<boolean>(false);

  const hasSubItens = route.children && route.children?.length;

  const handleClick = React.useCallback(() => {
    setOpen(o => !o);
  }, []);

  if (hasSubItens) {
    return (
      <div className={menuItemClasses.divMenuItem}>
        <Item
          endAdornment={open ? <ExpandLess /> : <ExpandMore />}
          route={route}
          handleClick={handleClick}
          component={component}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {route.children?.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                    role="presentation"
                  >
                    <Item route={item} component={component} isChildren />
                  </div>
                );
              })}
            </List>
          </Collapse>
        </Item>
      </div>
    );
  }

  return (
    <div
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      role="presentation"
    >
      <Item route={route} component={component} />
    </div>
  );
};

export default MenuItem;
